import ToggleMissionHeight from '~/javascripts/behaviors/ToggleMissionHeight';
import pluralize from 'pluralize';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';

const CommunityBoardHeader = observer(
  ({ bio, memberCount, logo, teamName }) => {
    const missionStatementEl = useRef(null);

    useEffect(() => {
      store.team.memberCount = memberCount;
      ToggleMissionHeight($(missionStatementEl.current));
    }, []);

    return (
      <>
        <div className='border border-b-0 border-solid px-2 pb-2 border-grey-30 hidden md-block'>
          <div className='logo' dangerouslySetInnerHTML={{ __html: logo }} />

          <h3 className='p40 text-center'> About {teamName} </h3>

          <div
            className='desktop-mission-wrapper py-1'
            data-max-char='275'
            data-min-height='120'
            ref={missionStatementEl}
          >
            <div
              className='mission-statement text-cw-black p40 text-center'
              dangerouslySetInnerHTML={{ __html: bio }}
            />
            <a
              className='p40 toggle-desktop-mission'
              data-toggle-less='Read Less'
              data-toggle-more='Read More'
            >
              Read More
            </a>
          </div>
        </div>

        <div className='team-member-count md-dashed-line px-2 py-1 border border-l-0 border-r-0 md-border-l md-border-r md-border-t-0 border-solid border-grey-30'>
          <p>{pluralize('Member', store.team.memberCount, true)}</p>
        </div>
      </>
    );
  }
);

export default CommunityBoardHeader;
